module.exports = __webpack_public_path__ + "static/img/hand.dd8e74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hand.png
// module id = u9ek
// module chunks = 1